import { gql } from '@apollo/client'

export const SAVE_USER = gql`
  mutation createOrUpdateUser($input: UserInput!) {
    createOrUpdateUser(input: $input) {
      id
    }
  }
`
